import { defineMessages } from 'react-intl';

const logoutMessages = defineMessages({
  forMoreInformation: {
    id: 'logout.forMoreInformation.text',
    defaultMessage: `For more information, see <link>these instructions</link>.`,
    description: 'For more information link',
  },
  lwaSignOutInstructionsOne: {
    id: 'logout.lwaSignOutInstructionsOne',
    defaultMessage: `Navigate to the Amazon website`,
    description: 'LWA Sign Out Instructions One',
  },
  lwaSignOutInstructionsTwo: {
    id: 'logout.lwaSignOutInstructionsTwo',
    defaultMessage: `Select Accounts & Lists in the top right`,
    description: 'Lwa Sign Out Instructions Two',
  },
  lwaSignOutInstructionsThree: {
    id: 'logout.lwaSignOutInstructionsThree',
    defaultMessage: `In the drop-down menu that appears, select Sign Out`,
    description: 'Lwa Sign Out Instructions Three',
  },
  bidSignOutInstructionsSkillBuilderUpdated: {
    id: 'logout.bidSignOutInstructionsSkillBuilderUpdated',
    defaultMessage: `You are now signed out of <skillbuilderurl>{lxp}</skillbuilderurl>, however you may still be signed into AWS Builder ID on this device. To sign out of AWS Builder ID completely, visit <link>https://profile.aws.amazon.com</link> and sign out. {br} {br} For more information, see <instructions>these instructions.</instructions>`,
  },
  amazonFederateSignOutInstructionsSkillBuilderUpdated: {
    id: 'logout.amazonFederateSignOutInstructionsSkillBuilderUpdated',
    defaultMessage: `You are now signed out of <skillbuilderurl>{lxp}</skillbuilderurl>, however you may still be signed into Amazon employee single sign-on on this device. To sign out of Amazon employee single sign-on completely, follow <link>these instructions.</link>`,
  },
  awsPartnerNetworkSignOutInstructionsSkillBuilderUpdated: {
    id: 'logout.awsPartnerNetworkSignOutInstructionsSkillBuilderUpdated',
    defaultMessage: `You are now signed out of <skillbuilderurl>{lxp}</skillbuilderurl>, however you may still be signed into AWS Partner Network on this device. To sign out of AWS Partner Network completely, visit <link>AWS Partner Central</link> and logout.`,
  },
  organizationESSOSignOutInstructionsSkillBuilderUpdated: {
    id: 'logout.organizationESSOSignOutInstructionsSkillBuilderUpdated',
    defaultMessage: `You are now signed out of <skillbuilderurl>{lxp}</skillbuilderurl>, however you may still be signed into Organization SSO on this device. `,
  },
  emailOtpSignOutInstructionsSkillBuilderUpdated: {
    id: 'logout.emailOtpSignOutInstructionsSkillBuilderUpdated',
    defaultMessage: `You are now signed out of <skillbuilderurl>{lxp}</skillbuilderurl>, however you may still be signed into One-time passcode on this device. `,
  },
  bidSignOutInstructionsUpdated: {
    id: 'logout.bidSignOutInstructionsUpdated',
    defaultMessage: `You are now signed out of {lxp}, however you may still be signed into AWS Builder ID on this device. To sign out of AWS Builder ID completely, visit <link>https://profile.aws.amazon.com</link> and sign out. {br} {br} For more information, see <instructions>these instructions.</instructions>`,
  },
  bidSignOutInstructionsGlobal: {
    id: 'logout.bidSignOutInstructionsGlobal',
    defaultMessage: `You are now signed out of {lxp} on all devices, however you may still be signed into AWS Builder ID on this device. To sign out of AWS Builder ID completely, visit <link>https://profile.aws.amazon.com</link> and sign out. {br} {br} For more information, see <instructions>these instructions.</instructions>`,
  },
  amazonFederateSignOutInstructionsUpdated: {
    id: 'logout.amazonFederateSignOutInstructionsUpdated',
    defaultMessage: `You are now signed out of {lxp}, however you may still be signed into Amazon employee single sign-on on this device. To sign out of Amazon employee single sign-on completely, follow <link>these instructions.</link>`,
  },
  amazonFederateSignOutInstructionsGlobal: {
    id: 'logout.amazonFederateSignOutInstructionsGlobal',
    defaultMessage: `You are now signed out of {lxp} on all devices, however you may still be signed into Amazon employee single sign-on on this device. To sign out of Amazon employee single sign-on completely, follow <link>these instructions.</link>`,
  },
  awsPartnerNetworkSignOutInstructionsUpdated: {
    id: 'logout.awsPartnerNetworkSignOutInstructionsUpdated',
    defaultMessage: `You are now signed out of {lxp}, however you may still be signed into AWS Partner Network on this device. To sign out of AWS Partner Network completely, visit <link>AWS Partner Central</link> and logout.`,
  },
  awsPartnerNetworkSignOutInstructionsGlobal: {
    id: 'logout.awsPartnerNetworkSignOutInstructionsGlobal',
    defaultMessage: `You are now signed out of {lxp} on all devices, however you may still be signed into AWS Partner Network on this device. To sign out of AWS Partner Network completely, visit <link>AWS Partner Central</link> and logout.`,
  },
  organizationESSOSignOutInstructionsUpdated: {
    id: 'logout.organizationESSOSignOutInstructionsUpdated',
    defaultMessage: `You are now signed out of {lxp}, however you may still be signed into Organization SSO on this device. `,
  },
  organizationESSOSignOutInstructionsGlobal: {
    id: 'logout.organizationESSOSignOutInstructionsGlobal',
    defaultMessage: `You are now signed out of {lxp} on all devices, however you may still be signed into Organization SSO on this device. `,
  },
  emailOtpSignOutInstructionsUpdated: {
    id: 'logout.emailOtpSignOutInstructionsUpdated',
    defaultMessage: `You are now signed out of {lxp}, however you may still be signed into One-time passcode on this device. `,
  },
  emailOtpSignOutInstructionsGlobal: {
    id: 'logout.emailOtpSignOutInstructionsGlobal',
    defaultMessage: `You are now signed out of {lxp} on all devices, however you may still be signed into One-time passcode on this device. `,
  },
  fallbackLxpName: {
    id: 'logout.fallbackLxpName',
    defaultMessage: 'the service',
    description: 'Fallback LXP name',
  },
  returnToHomepage: {
    id: 'logout.returnToHomepage',
    defaultMessage: 'Return to {lxp}',
    description: 'Button to return to the LXP homepage',
  },
});

export default logoutMessages;
